define("settings/templates/groups/group/social_profiles/edit", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f

  var _default = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{action this.closeModal}} as |modal|>
    <modal.card @portrait={{true}} class="u--p__b">
      <modal.card-header @title={{t "account.social_accounts.details.title"}} />
      <modal.card-body>
        <div class="u--m__0 u--inline">
          <Shared::ProfileAvatar
            @showDetails={{true}}
            @showPlatform={{true}}
            @showProfileType={{this.socialProfile.isLinkedin}}
            @socialProfile={{this.socialProfile}}
          />
        </div>
        <span class="u--float--right u--text--light u--m__b">
          {{t "account.social_accounts.details.added_on"}}
          {{format-date this.socialProfile.createdMoment}}
        </span>
        <hr />
        <p class="u--m__t__md u--m__b__xs">
          {{t "account.social_accounts.details.choose_profile_color"}}
        </p>
        <div class="u--p__tb__0">
          {{#each this.availableColors as |colorClass|}}
            <Shared::Ui::ProfileColorOption
              @colorClass={{colorClass}}
              @socialProfile={{this.socialProfile}}
              @trackSelection={{action this.trackChangedProfileColor}}
            />
          {{/each}}
        </div>
        <hr />
        <Cluster::SocialProfileTabs
          @activeTab={{this.tab}}
          @addRemoveDevice={{action this.addRemoveDevice}}
          @devices={{this.devices}}
          @saveSocialProfile={{task this.saveSocialProfile this.socialProfile}}
          @socialProfile={{this.socialProfile}}
        />
      </modal.card-body>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "gwJbqlVD",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[28,[37,1],[[30,0],[30,0,[\"closeModal\"]]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],[[24,0,\"u--p__b\"]],[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],null,[[\"@title\"],[[28,[37,2],[\"account.social_accounts.details.title\"],null]]],null],[1,\"\\n    \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n      \"],[10,0],[14,0,\"u--m__0 u--inline\"],[12],[1,\"\\n        \"],[8,[39,3],null,[[\"@showDetails\",\"@showPlatform\",\"@showProfileType\",\"@socialProfile\"],[true,true,[30,0,[\"socialProfile\",\"isLinkedin\"]],[30,0,[\"socialProfile\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,1],[14,0,\"u--float--right u--text--light u--m__b\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"account.social_accounts.details.added_on\"],null]],[1,\"\\n        \"],[1,[28,[35,4],[[30,0,[\"socialProfile\",\"createdMoment\"]]],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"hr\"],[12],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--m__t__md u--m__b__xs\"],[12],[1,\"\\n        \"],[1,[28,[35,2],[\"account.social_accounts.details.choose_profile_color\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"u--p__tb__0\"],[12],[1,\"\\n\"],[42,[28,[37,6],[[28,[37,6],[[30,0,[\"availableColors\"]]],null]],null],null,[[[1,\"          \"],[8,[39,7],null,[[\"@colorClass\",\"@socialProfile\",\"@trackSelection\"],[[30,2],[30,0,[\"socialProfile\"]],[28,[37,1],[[30,0],[30,0,[\"trackChangedProfileColor\"]]],null]]],null],[1,\"\\n\"]],[2]],null],[1,\"      \"],[13],[1,\"\\n      \"],[10,\"hr\"],[12],[13],[1,\"\\n      \"],[8,[39,8],null,[[\"@activeTab\",\"@addRemoveDevice\",\"@devices\",\"@saveSocialProfile\",\"@socialProfile\"],[[30,0,[\"tab\"]],[28,[37,1],[[30,0],[30,0,[\"addRemoveDevice\"]]],null],[30,0,[\"devices\"]],[28,[37,9],[[30,0,[\"saveSocialProfile\"]],[30,0,[\"socialProfile\"]]],null],[30,0,[\"socialProfile\"]]]],null],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"colorClass\"],false,[\"shared/modal\",\"action\",\"t\",\"shared/profile-avatar\",\"format-date\",\"each\",\"-track-array\",\"shared/ui/profile-color-option\",\"cluster/social-profile-tabs\",\"task\"]]",
    "moduleName": "settings/templates/groups/group/social_profiles/edit.hbs",
    "isStrictMode": false
  });

  _exports.default = _default;
});